import type { ServicesManager } from '@wix/services-manager/types'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { SiteServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { RendererConfigurationDefinition } from '@wix/viewer-service-renderer-configuration/definition'
import { name } from './symbols'
import type { RendererConfigurationEditorHandlers } from './types'
import type { RendererConfigurationEditorService } from '@wix/viewer-service-renderer-configuration/types'

export const rendererConfigurationSideEffectsFactory = (
	servicesManager: ServicesManager
): IModelUpdatesHandlersImplementor<RendererConfigurationEditorHandlers> => ({
	featureName: name,
	handlers: {
		updateHipaaComplaint(isHipaaCompliant) {
			if (!servicesManager.hasService(RendererConfigurationDefinition)) {
				return
			}
			const rendererConfigurationService = servicesManager.getService(
				RendererConfigurationDefinition
			) as RendererConfigurationEditorService
			rendererConfigurationService._updateConfig({ isHipaaCompliant: !!isHipaaCompliant })
		},
		updateCurrency(currency) {
			if (!servicesManager.hasService(RendererConfigurationDefinition)) {
				return
			}
			const rendererConfigurationService = servicesManager.getService(
				RendererConfigurationDefinition
			) as RendererConfigurationEditorService
			rendererConfigurationService._updateConfig({ currency })
		},
	},
})

export const RendererConfigurationSideEffects = withDependencies(
	[SiteServicesManagerSymbol],
	rendererConfigurationSideEffectsFactory
)
